import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 px-4 overflow-hidden" data-id="element-103">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-900/20 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-104"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-106">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight tracking-tight" data-id="element-107">
            ¿Tu Cuerpo Te Traicionó en el Momento Menos Esperado?
          </h1>
          <h2 className="text-xl md:text-2xl font-semibold text-blue-400 mb-4" data-id="element-108">
            Descubre el protocolo de 7 minutos que reactiva el flujo sanguíneo
            natural de tus arterias... sin pastillas, sin efectos secundarios,
            sin vergüenza.
          </h2>
          <p className="text-sm md:text-base text-slate-400 mb-8 font-medium tracking-wide uppercase" data-id="element-109">
            Sin fórmulas mágicas. Sin esperar semanas. Sin que nadie tenga que
            saberlo.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-3xl mx-auto mb-10 text-left md:text-center" data-id="element-110">
          <p className="text-lg text-slate-300 leading-relaxed mb-4" data-id="element-111">
            Sabes exactamente de qué hablo.
          </p>
          <p className="text-lg text-slate-300 leading-relaxed mb-4" data-id="element-112">
            Ese instante donde el sudor frío recorre tu espalda. Donde tu mente
            grita "no otra vez" mientras sientes cómo la confianza se desmorona.
          </p>
          <p className="text-lg text-slate-300 leading-relaxed mb-4 font-medium" data-id="element-113">
            No es tu imaginación. No es "estrés". Y definitivamente no es el
            final de tu vida sexual.
          </p>
          <p className="text-lg text-slate-300 leading-relaxed mb-4" data-id="element-114">
            El problema real es que nadie te contó esto:{' '}
            <br className="hidden md:block" data-id="element-115" />
            <span className="text-blue-400 font-bold text-xl" data-id="element-116">
              Tus arterias tienen un "interruptor" olvidado.
            </span>
          </p>
          <p className="text-lg text-slate-300 leading-relaxed mb-4" data-id="element-117">
            Cuando se activa, el flujo sanguíneo responde de forma automática.
            Cuando está apagado, ni la mejor pastilla del mundo puede ayudarte
            por mucho tiempo.
          </p>
          <p className="text-lg text-white font-semibold leading-relaxed mb-6" data-id="element-118">
            La buena noticia: puedes encenderlo tú mismo en menos de 7 minutos.
          </p>
          <p className="text-lg text-slate-400 leading-relaxed font-medium" data-id="element-119">
            Sin químicos. Sin citas médicas incómodas. Sin gastar cientos de
            dólares en soluciones temporales.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mb-12 relative mx-auto max-w-2xl" data-id="element-120">
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent z-10 pointer-events-none" data-id="element-121"></div>
          <img src="https://cdn.magicpatterns.com/uploads/8GjQLx96Yv1ZmBqYHfPkFb/Antes.png" alt="Comparación Antes y Después" width={1080} height={1080} loading="eager" fetchPriority="high" decoding="async" className="w-full h-auto rounded-2xl shadow-2xl border border-slate-800" data-id="element-122" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-col items-center gap-4" data-id="element-123">
          <a href="#comprar" className="flex justify-center items-center gap-2 w-full max-w-md bg-blue-600 hover:bg-blue-500 text-white font-bold text-lg py-4 px-8 rounded-full transition-all duration-300 shadow-[0_0_20px_rgba(37,99,235,0.5)] hover:shadow-[0_0_35px_rgba(37,99,235,0.7)] hover:scale-105 active:scale-95" data-id="element-124">
            👉 Quiero el Protocolo + Bonos
          </a>

          <div className="flex items-center gap-2 text-slate-400 text-sm font-medium bg-slate-900/50 py-1.5 px-4 rounded-full border border-slate-800" data-id="element-125">
            <ShieldCheck className="w-4 h-4 text-amber-500" data-id="element-126" />
            <span data-id="element-127">Acceso inmediato por $14.99 USD (antes $59.99)</span>
          </div>
        </motion.div>
      </div>
    </section>;
}